import { slideQueryKeys } from "../../../types/Slides";
import { querySelectorURL } from "../../cpcoc/querySelectorURL";
const ignoreSlidesQuery = querySelectorURL("ignore");
const ignoreSlides = typeof ignoreSlidesQuery === "string" ? ignoreSlidesQuery : ""; // SlideName,
export function ignoreSlide(slideIndex) {
    return ignoreSlides.indexOf(Object.keys(slideQueryKeys)[slideIndex]) > -1;
}
